module.exports = __webpack_public_path__ + "static/media/agency_manager.46f7946d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/agency_manager.svg
// module id = 2701
// module chunks = 0